import { render, staticRenderFns } from "./translations.vue?vue&type=template&id=3e7022cb&"
import script from "./translations.vue?vue&type=script&lang=js&"
export * from "./translations.vue?vue&type=script&lang=js&"
import style0 from "./translations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports